import { useEffect,useState  } from 'react';
import { Route, Routes  } from 'react-router-dom';
import { sendRequst } from './helpers';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './components/HomePage/HomePage';
import CartPage from './pages/CartPage/CartPage';
import FavouritePage from './pages/FavouritePage/FavouritePage';
import VacanciesPage from './pages/VacanciesPage';
import ContactPage from './pages/ContactPage/ContactPage';
import BlogPage from './pages/BlogPage';
import './App.scss';


const App = (props) =>{




const [products,setProducts] = useState([])
const [loading, setLoading] = useState(true)


const addToCart=(id)=>{
      setCart(
      [...cart,id]
    )
      localStorage.setItem('cart', JSON.stringify([...cart, id]))
}
const removeFromCart =(id)=>{
      setCart(
      cart.filter((cartItem)=> cartItem !== id)
  )
      localStorage.setItem('cart', JSON.stringify(cart.filter((cartItem)=> cartItem !== id)))
}
const [cart,setCart] = useState(localStorage.getItem('cart')  ? JSON.parse(localStorage.getItem('cart')) : [])



const addToFavourite = (id) => {
        setFavourite(
        [...favourite, id]
)
        localStorage.setItem('fav', JSON.stringify([...favourite, id]))
}
const removeFromFavourite = (id) => {
        setFavourite(
        favourite.filter((fav) => fav !== id)
  )
        localStorage.setItem('fav', JSON.stringify(favourite.filter((fav) => fav !== id)))
}
const [favourite,setFavourite] = useState(localStorage.getItem('fav') ? JSON.parse(localStorage.getItem('fav')) : [])

const onChangeSelect = (event)=>{
  let currentGadgetType = event.target.value
  setGadgetType(currentGadgetType)
  
}

const selectGadjetType = (type) =>{
setGadgetType(type)
}
const [gadgetType,setGadgetType] = useState('all devices')


useEffect(() => {
  sendRequst('/products.json')
    .then(products => {
      setProducts(products);
      setLoading(false); 
    })
    .catch(error => {
      console.error(error);
      setLoading(false); 
    });
}, []);


return(
  <>
     <div className="App">
          <Header cartCount={cart.length} favCount={favourite.length}/>
          <Routes>
            <Route path='/'  element={
              <HomePage
              products = {products}
                    addToCart={addToCart} 
                    removeFromCart={removeFromCart} 
                    cart ={cart} 
                    favourite={favourite}
                    addToFavourite = {addToFavourite}
                    removeFromFavourite = {removeFromFavourite}
                    loading={loading}
                    gadgetType={gadgetType}
                    onChangeSelect={onChangeSelect}
                    />
                  } 
                />
                <Route path='/home' element={
                    <HomePage
                    products= {products}
                      addToCart={addToCart} 
                      removeFromCart={removeFromCart} 
                      cart ={cart} 
                      favourite={favourite}
                      addToFavourite = {addToFavourite}
                      removeFromFavourite = {removeFromFavourite}
                      gadgetType={gadgetType}
                      onChangeSelect={onChangeSelect}/> 
                      } 
                  />
                  
                  <Route path='/cart' element={<CartPage removeFromCart={removeFromCart} cartItemId={cart}/>} />
                  <Route path='/favourite' element={
                        <FavouritePage
                        cartItem={cart}
                        products= {products}
                        addToCart={addToCart} 
                        removeFromCart={removeFromCart}  
                        favourite={favourite}
                        addToFavourite = {addToFavourite}
                        removeFromFavourite = {removeFromFavourite}
                        />
                        
                  
                  } />
                  <Route path='/vacancies' element={<VacanciesPage/>}/>
                  <Route path='/contact' element={<ContactPage/>}/>
                  <Route path='/blog' element={<BlogPage/>}/>
          
          
          </Routes>
          <Footer selectGadjetType={selectGadjetType}/>
          
    </div>
    
  </>
)
}

export default App;


